import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { SelectField } from './AdminFields';

const STATUS = [['new', 'New'], ['contacted', 'Contacted'], ['won', 'Won'], ['lost', 'Lost']];

const FinderLeadsAdmin = () => {
    const [items, setItems] = useState([]);
    const load = () => api.get('/admin/finder-leads').then((r) => setItems(r.data));
    useEffect(() => { load(); }, []);
    const setStatus = async (l, status) => {
        await api.put(`/admin/finder-leads/${l.id}`, { status });
        toast.success('Lead updated');
        load();
    };
    return (
        <div data-testid="admin-finder-leads">
            <h2 className="font-display font-black uppercase text-3xl mb-2">Machine Finder leads</h2>
            <p className="text-white/50 text-sm mb-6">Shoppers who emailed themselves a Machine Finder result. Follow up while they&apos;re still deciding.</p>
            <div className="border border-white/10 divide-y divide-white/10" data-testid="admin-finder-leads-list">
                {items.length === 0 && <div className="p-6 text-white/50">No finder leads yet.</div>}
                {items.map((l) => (
                    <div key={l.id} className="p-4 grid grid-cols-1 md:grid-cols-12 gap-3 items-start" data-testid={`admin-finder-lead-${l.id}`}>
                        <div className="md:col-span-3">
                            <a href={`mailto:${l.email}`} className="font-display font-bold text-brand-primary break-all">{l.email}</a>
                            <div className="text-sm text-white/50">{l.name || '—'} · {new Date(l.created_at).toLocaleDateString()}</div>
                        </div>
                        <div className="md:col-span-6 text-sm text-white/70">
                            <div className="font-bold text-white">{l.tier_label}</div>
                            <div>{(l.products || []).join(' · ') || '—'}</div>
                            <div className="text-white/50 mt-1">{(l.answer_labels || []).join(' / ')}</div>
                            <a href={l.result_url} target="_blank" rel="noreferrer" className="text-brand-primary text-xs label-caps">Open their result</a>
                        </div>
                        <div className="md:col-span-3">
                            <SelectField label="Status" value={l.status} onChange={(v) => setStatus(l, v)} options={STATUS} testid={`admin-finder-lead-status-${l.id}`} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FinderLeadsAdmin;
